import axios from 'axios';

export default {
    postScheduleAppointment(cb, { data, dealerId, clientToken }) {
        axios
            .post('/api/appointment', 
                data, {
                headers: {
                        Authorization: `Bearer ${clientToken}`,
                        Dealer: dealerId
                } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response?.data ?? null));
    },
    getClinicInformation(cb, { clinicUrl, dealerId, clientToken }) {
        axios
            .get('/api/Clinic', {
                params: {
                    clinicUrl
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response?.data ?? null));
    },
    getStaff(cb, { clinicId, dealerId, clientToken }) {
        axios
            .get('/api/Staff', {
                params: {
                    clinicId
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response?.data ?? null));
    },
    getAppointmentTimeslots(cb, { startDate, endDate, appointmentType, clinicId, staffId, dealerId, clientToken }) {
        axios
            .get('/api/Appointment/timeslots', {
                params: {
                    startDate,
                    endDate,
                    appointmentType,
                    clinicId,
                    staffId
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response?.data ?? null));
    },
    getCompanionTypes(cb, { dealerId, clientToken }) {
        axios
            .get('/api/CompanionType', {
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response?.data ?? null));
    }
};
